/**
 * File top-banner.js.
 * Handles dismissing top banner,
 * tracking top banner CTA clicks
 */

const header = document.querySelector('.header');
const topBannersDesktop = document.querySelectorAll('.top-banner--desktop');
const topBannersMobile = document.querySelectorAll('.top-banner--mobile');

const baseTopBannerCookieName = 'topBannerDismissed';

/**
 * Show/hide banner
 */

function closeBanner(banner, permanently = true) {
  if (banner?.id == null) {
    return;
  }

  if (permanently) {
    const bannerCookieName = `${baseTopBannerCookieName}#${banner.id}`;
    document.cookie = `${bannerCookieName}=true;path=/`;
  }
  
  const desktopBanner = document.querySelector(`#${banner.id}.top-banner--desktop`);
  const mobileBanner = document.querySelector(`#${banner.id}.top-banner--mobile`);

  if (desktopBanner != null) {
    desktopBanner.parentElement.removeChild(desktopBanner);
    intitializeHeights(
      document.querySelectorAll(".top-banner--desktop"), 1, (space) => {
      document.documentElement.style.setProperty('--top-banner-desktop-height', `${space}px`);
    });
  }

  if (mobileBanner != null) {
    mobileBanner.parentElement.removeChild(mobileBanner);
    intitializeHeights(
      document.querySelectorAll(".top-banner--mobile"),
      document.querySelector('.blog-nav')?.offsetHeight - 1
    );
  }

  if (document.querySelectorAll('.top-banner').length === 0) {
    header.classList.remove('header--top-banner');
  }
}

/**
 * Track banner CTA clicks
 */
function trackBannerClick(e) {
  e.preventDefault();

  const goToCta = redirect(e.target.href);
  const properties = {
    cta_name: "Top Banner CTA",
    location: window.location.href
  };

  segment(
    'track',
    'Landing Page CTA Tapped',
    properties,
    goToCta
  );
}

/**
 * Inits
 */

const intitializeHeights = (banners, initHeight = 0, callback = (_) => {}) => {
  let space = initHeight;
  banners.forEach(banner => {
    banner.style.top = `${space - 1}px`;
    space += banner.offsetHeight;
  });

  callback(space);
}

const initBanners = (banners, initHeight = 0, callback = (_) => {}) => {
  if (banners.length === 0) {
    return;
  }

  let space = initHeight;

  banners.forEach(banner => {
    if (document.cookie.indexOf(`${baseTopBannerCookieName}#${banner.id}`) !== -1) {
      banner.parentElement.removeChild(banner);
      return;
    }

    banner.style.display = 'block';

    banner.style.top = `${space - 1}px`;
    space += banner.offsetHeight;

    banner.style.removeProperty('display');

    const topBannerClose = banner.querySelector('.top-banner__close-btn');     
    if (topBannerClose) topBannerClose.addEventListener('click', function () {
      closeBanner(banner);
    });

    // add click event to track CTA clicks
    const topBannerCta = banner.querySelector('.top-banner__cta');
    if (topBannerCta) topBannerCta.addEventListener('click', trackBannerClick);
  })

  callback(space);
}

initBanners(topBannersDesktop, 1, (space) => {
  document.documentElement.style.setProperty('--top-banner-desktop-height', `${space}px`);
});

initBanners(topBannersMobile, document.querySelector('.blog-nav')?.offsetHeight - 1);

if (document.querySelectorAll('.top-banner').length > 0) {
  header.classList.add('header--top-banner');
}
